module.exports = __webpack_public_path__ + "static/media/meeting_devil.d4624606.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/books/originals/meeting_devil.jpg
// module id = 117
// module chunks = 0